import {
  createContext,
  useContext,
  useEffect,
  useState,
} from "react";

import { supabase } from "../lib/supabase";

const AuthContext = createContext();
const SESSION_DURATION = 24 * 60 * 60 * 1000;

export function AuthProvider({ children }) {

  const [user, setUser] = useState(null);

  const [loading, setLoading] = useState(true);

  const [role, setRole] = useState("");

  useEffect(() => {

    let mounted = true;

    const fetchSession = async () => {

      try {

        const {
          data: { session },
        } = await supabase.auth.getSession();

        if (!mounted) return;

        const currentUser = session?.user || null;
        if (currentUser && !localStorage.getItem("loginTime")) {
          localStorage.setItem(
           "loginTime",
          Date.now().toString()
     );
    }

// Check if session has expired
const loginTime = localStorage.getItem("loginTime");

if (
  currentUser &&
  loginTime &&
  Date.now() - Number(loginTime) > SESSION_DURATION
) {
  await supabase.auth.signOut();

  localStorage.removeItem("loginTime");

  setUser(null);
  setRole("");

  window.location.replace("/auth");
  return;
}

setUser(currentUser);

if (currentUser?.email?.endsWith("@codeion.in")) {
  setRole("instructor");
} else {
  setRole("student");
}

      } catch (error) {

        console.error(error);

      } finally {

        if (mounted) {

          setLoading(false);

        }

      }

    };

    fetchSession();

    const {
      data: authListener,
    } = supabase.auth.onAuthStateChange(
      async (_event, session) => {

        const currentUser = session?.user || null;

if (_event === "SIGNED_IN") {
  localStorage.setItem(
    "loginTime",
    Date.now().toString()
  );
}

setUser(currentUser);

        if (
          currentUser?.email?.endsWith("@codeion.in")
        ) {

          setRole("instructor");

        } else {

          setRole("student");

        }

        setLoading(false);
      }
    );

    return () => {

      mounted = false;

      authListener?.subscription?.unsubscribe();

    };

  }, []);

  const logout = async () => {

    try {

      await supabase.auth.signOut();

      localStorage.removeItem("loginTime");
      sessionStorage.clear();

      setUser(null);

      setRole("");

      window.location.href = "/logout";

    } catch (error) {

      console.error(error);

    }

  };

  return (
    <AuthContext.Provider
      value={{
        user,
        role,
        loading,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () =>
  useContext(AuthContext);